// ============= List of APIs for MyHub =============

export const resetPassword = `${process.env.REACT_APP_MYHUB_API_GATEWAY}/ResetPassword`;
export const userRegistration = `${process.env.REACT_APP_MYHUB_API_GATEWAY}/Register`;
export const userLogin = `${process.env.REACT_APP_MYHUB_API_GATEWAY}/Login`;
export const extendToken = `${process.env.REACT_APP_MYHUB_API_GATEWAY}/ExtendToken`;
export const handleMedia = `${process.env.REACT_APP_MYHUB_API_GATEWAY}/media-handle`;
export const dbUserAndHub = `${process.env.REACT_APP_MYHUB_API_GATEWAY}/UserAndHubdb`;
export const dbOrders = `${process.env.REACT_APP_MYHUB_API_GATEWAY}/OrderService`;

const ZINIHUB_WEBSOCKET_API_ID = process.env.REACT_APP_ZINIHUB_WEBSOCKET_ID || '3sa13p4ac2';
const ZINIHUB_WEBSOCKET_REGION = 'ap-south-1';

const resolveDeployStage = (rawDeployEnv) => {
  const normalizedDeployEnv = String(rawDeployEnv || 'Test').trim().toLowerCase();
  return normalizedDeployEnv === 'prod' ? 'Prod' : 'Test';
};

const fallbackZiniHubWebSocket =
  `wss://${ZINIHUB_WEBSOCKET_API_ID}.execute-api.${ZINIHUB_WEBSOCKET_REGION}.amazonaws.com/${resolveDeployStage(process.env.REACT_APP_DEPLOY_ENV)}/`;

export const ziniHubWebSocket = process.env.REACT_APP_ZINIHUB_WEBSOCKET || fallbackZiniHubWebSocket;
